import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { useAuth } from '../../context/AuthContext';
import { getRoleLabel } from '../../constants/roles';

export default function BlogComments() {
  const { isAuthenticated, profile } = useAuth();
  const [commentText, setCommentText] = useState('');
  const navigate = useNavigate();

  const displayName = profile?.full_name || 'Tú';
  const initials = displayName.charAt(0).toUpperCase();

  return (
    <div className="mt-20 pt-16 border-t border-[var(--border-subtle)]">
      <div className="flex items-center justify-between mb-10">
        <h3 className="text-2xl font-black text-[var(--text-main)] uppercase italic tracking-tight">
          Comentarios
        </h3>
      </div>

      {!isAuthenticated ? (
        <div className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-3xl p-8 md:p-12 text-center shadow-sm">
          <div className="w-16 h-16 bg-[var(--bg-base)] rounded-full flex items-center justify-center mx-auto mb-6 border border-[var(--border-subtle)]">
            <SafeIcon name="Lock" className="w-6 h-6 text-[var(--text-secondary)]" />
          </div>
          <h4 className="text-xl font-black text-[var(--text-main)] uppercase italic mb-3">
            Sé parte de la conversación
          </h4>
          <p className="text-[var(--text-secondary)] text-sm font-medium mb-8 max-w-md mx-auto">
            Los comentarios son exclusivos para los miembros de GFI Latino. Únete al movimiento para conectar con otros líderes y compartir tu perspectiva.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => navigate('/login')}
              className="gfi-gradient-bg text-brand-navy px-8 py-3.5 rounded-full font-black text-xs uppercase tracking-widest transition-all transform hover:scale-105 shadow-lg"
            >
              Iniciar Sesión
            </button>
            <button
              onClick={() => navigate('/registro')}
              className="bg-[var(--bg-base)] text-[var(--text-main)] border border-[var(--border-subtle)] px-8 py-3.5 rounded-full font-black text-xs uppercase tracking-widest transition-all hover:bg-[var(--border-subtle)]"
            >
              Sumarme al Movimiento
            </button>
          </div>
        </div>
      ) : (
        <div>
          <form 
            onSubmit={(e) => { e.preventDefault(); setCommentText(''); }} 
            className="flex gap-4 mb-12"
          >
            <div className="w-12 h-12 rounded-full bg-[var(--bg-surface)] border border-[var(--border-subtle)] flex-shrink-0 flex items-center justify-center text-sm font-black text-[var(--text-main)]">
              {initials}
            </div>
            <div className="flex-1 relative">
              <textarea 
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                placeholder="Comparte tus ideas con la comunidad..."
                className="w-full bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-2xl py-4 px-6 pr-16 text-sm text-[var(--text-main)] placeholder-[var(--text-secondary)]/50 focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan transition-all resize-none min-h-[100px]"
              />
              <button 
                type="submit" 
                disabled={!commentText.trim()}
                className="absolute right-4 bottom-4 w-10 h-10 rounded-full gfi-gradient-bg flex items-center justify-center text-brand-navy disabled:opacity-50 disabled:grayscale transition-all hover:scale-105 active:scale-95"
              >
                <SafeIcon name="Send" className="w-4 h-4 ml-0.5" />
              </button>
            </div>
          </form>

          <div className="space-y-8">
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-full bg-brand-navy flex-shrink-0 flex items-center justify-center text-sm font-black text-white">
                {initials}
              </div>
              <div className="flex-1">
                <div className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-2xl rounded-tl-none p-5">
                  <div className="flex items-baseline justify-between mb-2">
                    <span className="font-black text-[var(--text-main)] uppercase tracking-tight text-sm">
                      {displayName}
                    </span>
                    <span className="text-[10px] font-bold uppercase tracking-widest text-[var(--text-secondary)]">
                      {getRoleLabel(profile?.role)}
                    </span>
                  </div>
                  <p className="text-[var(--text-main)]/80 text-sm leading-relaxed font-medium">
                    Excelente contenido. Implementé estos conceptos en mi última cita y el cliente entendió perfectamente el valor de prepararse para el futuro.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
